import { baseApi } from '@/shared/api'
import type { SupplierPriceList, SupplierPriceQuery } from '../model/types'

export const supplierPriceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Поиск по прайсам поставщиков. Разбор режима (`search` либо `f1..f5`), сортировка, страница
     * и итоги — на сервере (правило 11). Параметры уходят как есть; модификатор контекста не
     * добавляется. База прайсов недоступна — ручка отвечает `503 supplier-prices.unavailable`.
     */
    getSupplierPrices: build.query<SupplierPriceList, SupplierPriceQuery>({
      query: (params) => ({ url: '/catalog/supplier-prices', params }),
      providesTags: [{ type: 'SupplierPrice', id: 'LIST' }],
    }),
  }),
})

export const { useGetSupplierPricesQuery } = supplierPriceApi
